import { Controller } from '@hotwired/stimulus'
import Highcharts from 'highcharts'
import HcExporting from 'highcharts/modules/exporting'
import HcExportData from 'highcharts/modules/export-data'

HcExporting(Highcharts)
HcExportData(Highcharts)

export default class extends Controller {
  static targets = [ 'chart', 'form', 'loader' ]
  static values  = { url: String, stacking: Boolean }
  static classes = [ 'hidden' ]

  connect() {
    this.changePeriod()
  }

  initChart() {
    this.chart = Highcharts.chart(this.chartTarget, {
      chart: { type: 'column' },
      plotOptions: { column: { stacking: 'normal' } },
      yAxis: { title: { text: "Certifications femmes" } },
      exporting: { buttons: { contextButton: { menuItems: ['downloadXLS', 'downloadCSV'] } } },
      navigation: { menuItemHoverStyle: { background: '#db2777', color: '#ffffff' } }
    })

  }

  load() {
    this.reset()
    this.getData()
  }

  reset() {
    if (this.chart) this.chart.destroy()
    this.initChart()
  }

  changePeriod() {
    let period = this.formTarget.querySelector("[data-period-select]").value
    this.formTarget.querySelectorAll("[data-period]").forEach(element => element.classList.add(this.hiddenClass))
    this.formTarget.querySelectorAll(`[data-period*="${period}"]`).forEach(element => element.classList.remove(this.hiddenClass))
    this.reset()
    this.getData()
  }

  getData() {
    this.loaderTarget.classList.remove(this.hiddenClass)
    let url = new URL(this.urlValue)
    url.search = new URLSearchParams(new FormData(this.formTarget)).toString()

    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(response => response.json())
      .then(data => {
        this.chart.xAxis[0].setCategories(data.ticks)

        data.series.forEach(series => {
          this.chart.addSeries(series)
        })

        this.loaderTarget.classList.add(this.hiddenClass)
      })
  }
}
